import React from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

import { ServiceGroup } from '@/types/serviceGroup';
import { GLSContainer } from '@/components/pages/Service/Detail/GLS/Root';
import { NONGLSContainer } from '@/components/pages/Service/Detail/NONGLS/Root';
import { NoticeContainer } from '@/components/shared/Notice';

const GLSID = 4;
const isGLS = (serviceId: number) => serviceId === GLSID;

export const ServiceDetail: React.FC<{
  service?: ServiceGroup;
}> = ({ service }) => {
  return service ? (
    <>
      <Helmet>
        <title>{service.name}</title>
      </Helmet>
      <InnerWrapper>
        <Image url={service.imageUrl} />
        <NoticeContainer />
        <Content>
          {isGLS(service.id) ? (
            <GLSContainer service={service} />
          ) : (
            <NONGLSContainer service={service} />
          )}
        </Content>
      </InnerWrapper>
    </>
  ) : null;
};

const InnerWrapper = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  margin-top: 56px !important;
`;

// width: 画面幅に合わせる;
// height: 画像の縦横比と画面幅から計算;
const Image = styled.div<{ url: string }>`
  width: 100vw;
  height: calc(100vw * (494 / 1920));
  background: ${(props) => `url(${props.url})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const Content = styled.div`
  margin: 4em auto;
  width: 934px;
`;
